<template>
  <div class="button-wrapper">
    <b-button v-if="!hideEdit" variant="outline-primary" class="button__edit" @click="onEdit">
      <font-awesome-icon
        class="icon__upload-img"
        :icon="{ prefix: 'fas', iconName: 'crop-simple' }"
      />
      Edit
    </b-button>

    <!-- Upload button -->
    <b-button
      v-if="!hideUpload"
      variant="outline-primary"
      class="button__upload mx-2"
      @click="$refs.input__upload.click()"
    >
      <font-awesome-icon class="icon__upload-img" :icon="{ prefix: 'far', iconName: 'image' }" />
      <input
        v-show="false"
        ref="input__upload"
        type="file"
        accept="image/*"
        @change="onUpload($event)"
      />
      New Picture
    </b-button>

    <!-- Delete button -->

    <b-button
      v-if="!hideDelete"
      variant="outline-danger"
      class="button__delete"
      @click="onDelete()"
    >
      <font-awesome-icon
        class="icon__upload-img"
        :icon="{ prefix: 'far', iconName: 'trash-can' }"
      />
      Delete
    </b-button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faImage as faRegularImage,
  faTrashCan as faRegularfaTrashCan
} from '@fortawesome/free-regular-svg-icons';
import { faCropSimple } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faRegularImage, faRegularfaTrashCan, faCropSimple);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    hideEdit: {
      type: Boolean,
      default: false
    },
    hideUpload: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onDelete() {
      this.$emit('onDelete');
    },
    onEdit() {
      this.$emit('onEdit');
    },
    onUpload(event) {
      this.$emit('onUpload', event.target.files[0]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
